<template>
    <AppLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Challenge Detail
            </h2>
        </template>
        <div class="grid grid-cols-1 p-12 gap-y-10">
            <div>
                <div class="grid grid-cols-3">
                    <div>
                        <div class="flex items-center gap-1">
                            <button
                                class="bg-gray-600 hover:bg-gray-900 font-bold py-1 px-2 my-2 rounded-md text-white flex"
                                @click="back">

                                <ChevronLeftIcon class="w-6 h-6"></ChevronLeftIcon>

                            </button>
                            <h3 class="text-lg font-medium leading-6 text-gray-900">
                                Challenge Detail
                            </h3>
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div
                            class="bg-white overflow-hidden shadow sm:rounded-lg"
                        >
                            <div class="px-4 py-5 sm:p-6">
                                <input-row
                                    desc="Challenge"
                                    v-model="challenge.name"
                                    :disabled="true"
                                >
                                </input-row>

                                <input-row
                                    desc="Description"
                                    v-model="challenge.description"
                                    :disabled="true"
                                    class="mt-14"
                                >
                                </input-row>

                                <input-row
                                    desc="Project"
                                    v-model="project"
                                    :disabled="true"
                                    class="mt-14"
                                >
                                </input-row>

                                <input-row
                                    desc="Challenge Goal"
                                    v-model="goal"
                                    :disabled="true"
                                    class="mt-14"
                                >
                                </input-row>

                                <input-row
                                    desc="Challenge Restrictions"
                                    v-model="restrictions"
                                    type="textarea"
                                    :disabled="true"
                                    class="mt-14"
                                >
                                </input-row>

                                <div class="flex sm:col-span-3 justify-center">
                                    <PrimaryButton
                                        v-if="!isEnrolled"
                                        class="mr-4"
                                        @click="confirmEnroll = true">
                                        Enroll Challenge
                                    </PrimaryButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="user.id == challenge.created_by">
                <div class="grid grid-cols-3">
                    <div>
                        <h3 class="text-lg font-medium leading-6 text-gray-900">
                            Participants
                        </h3>
                        <p class="mt-1 text-sm text-gray-600"></p>
                    </div>
                    <div class="col-span-2">
                        <div
                            class="bg-white overflow-hidden shadow sm:rounded-lg"
                        >
                            <div class="px-4 py-5 sm:p-6">
                                <AmazingIndexTable
                                    v-model="participants"
                                    :columns="tableColumns"
                                    :hasCheckbox="false"
                                    headerClasses="shadow overflow-hidden sm:rounded-lg"
                                >
                                    <!-- ID -->
                                    <template #header-id> ID</template>
                                    <template #body-id="{ item }">
                                        <td class="text-left pl-4" :class="{'text-red-500': item.hasRestriction}">
                                            {{ item.session_id || item.pivot.id }}
                                        </td>
                                    </template>

                                    <!-- Name -->
                                    <template #header-name> User</template>
                                    <template #body-name="{ item }">
                                        <td
                                            class="text-left px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                            :class="{'text-red-500': item.hasRestriction}"
                                        >
                                            {{ item.name }}
                                        </td>
                                    </template>

                                    <!-- Description -->
                                    <template #header-submit_date>
                                        Submit Date
                                    </template>
                                    <template #body-submit_date="{ item }">
                                        <td
                                            class="text-left px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500"
                                            :class="{'text-red-500': item.hasRestriction}"
                                        >
                                            {{ moment(item.pivot.created_at).format('DD/MM/YYYY') }}
                                        </td>
                                    </template>

                                    <!-- G -->
                                    <template #header-goal_value>
                                        Goal Value
                                    </template>
                                    <template #body-goal_value="{ item }">
                                        <td
                                            class="text-left px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500"
                                            :class="{'text-red-500': item.hasRestriction}"
                                        >
                                            {{ item.goal_value }} <span
                                            v-if="item.goal_unit"> ({{ item.goal_unit }})</span>
                                        </td>
                                    </template>

                                    <template #header-restrictions>
                                        Restriction
                                    </template>
                                    <template #body-restrictions="{ item }">
                                        <td
                                            v-if="item.hasRestriction"
                                            class="text-left px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500"
                                            :class="{'text-red-500': item.hasRestriction}"
                                        >
                                            {{ item.restrictions.join(', ')}}
                                        </td>
                                    </template>

                                    <!-- G -->
                                    <template #header-report>
                                        Report
                                    </template>
                                    <template #body-report="{ item }">
                                        <td
                                            class="text-left px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-500"
                                            :class="{'text-red-500': item.hasRestriction}"
                                        >
                                            <Link
                                                v-if="item.session_url"
                                                method="get"
                                                class="px-5 py-2 bg-slate-500 font-semibold text-white rounded-sm"
                                                as="button"
                                                :href="item.session_url"
                                            >Report
                                            </Link>
                                        </td>
                                    </template>
                                </AmazingIndexTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="grid grid-cols-3">
                    <div>
                        <h3 class="text-lg font-medium leading-6 text-gray-900">
                            Challenge Scope
                        </h3>
                        <p class="mt-1 text-sm text-gray-600">Area</p>
                    </div>
                    <div class="col-span-2">
                        <div
                            class="bg-white overflow-hidden shadow sm:rounded-lg"
                        >
                            <div class="px-4 py-5 sm:p-6">
                                <LeafletMap
                                    ref="map"
                                    :instances="instances"
                                    :links="links"
                                ></LeafletMap>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jet-confirmation-modal
            :show="confirmEnroll"
            @close="confirmEnroll = false">
            <template #title> Challenge Enroll</template>

            <template #content>
                are you sure you want to enroll the challenge?

                <Field label="Project"
                       class="mt-2"
                       hint="Select a project to enroll">
                    <SelectMenu v-model="currentProject" :options="projects"></SelectMenu>
                </Field>
            </template>

            <template #footer>
                <SecondaryOutlinedButton @click="confirmEnroll = false">
                    Cancel
                </SecondaryOutlinedButton>

                <PrimaryButton
                    class="ml-2"
                    @click="enroll">
                    Confirm
                </PrimaryButton>
            </template>
        </jet-confirmation-modal>
    </AppLayout>
</template>

<script setup>
import AppLayout from "@/Layouts/AppLayout";
import InputRow from "@/Components/InputRow";
import {ChevronLeftIcon} from '@heroicons/vue/solid'
import {Inertia} from "@inertiajs/inertia";
import AmazingIndexTable from "@/Components/Tables/AmazingIndexTable.vue";

import LeafletMap from "@/Components/LeafletMap";
import {onMounted, ref} from "vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import SecondaryOutlinedButton from "@/Components/SecondaryOutlinedButton.vue";
import JetConfirmationModal from "@/Jetstream/ConfirmationModal";
import {Link} from "@inertiajs/inertia-vue3";
import moment from 'moment';
import {notify} from "@kyvg/vue3-notification";
import Field from "../../Components/Field.vue";
import SelectMenu from "../../Components/Forms/SelectMenu.vue";

const props = defineProps({
    challenge: {
        type: Object,
        required: true,
    },
    participants: {
        type: Array,
        required: true,
    },
    instances: {
        type: Array,
        required: true,
    },
    links: {
        type: Array,
        required: true,
    },
    user: {
        type: Object,
        default: {}
    },
    isEnrolled: {
        type: Boolean,
        default: false
    },
    projects: {
        type: Array,
        required: true,
    }
})
const tableColumns = ["id", "name", 'submit_date', 'goal_value', 'report', 'restrictions'];
const back = () => Inertia.get(route('challenges.index'))
const unit = props.challenge.goal && props.challenge.goal.unit ? '(' + props.challenge.goal.unit + ')' : ''
const goal = props.challenge.goal ? props.challenge.goal.name + unit : ''
const project = props.challenge.project ? props.challenge.project.name : ''
let restrictions = ''
if (props.challenge.restrictions) {
    restrictions = props.challenge.restrictions.flatMap((restriction) => {
        let unit = restriction.unit ? '(' + restriction.unit + ')' : ''
        return restriction.name + ': ' + restriction.pivot.value + unit
    }).join('\n')
}
const confirmEnroll = ref(false);
const currentProject = ref();
const enroll = () => {
    axios.post('/enroll-challenge', {
        challenge: props.challenge.id,
        user: props.user.id,
        project: currentProject.value
    }).then(({data}) => {
        if (!data.error) {
            notify({
                group: "notifications",
                title: "Enroll",
                text: 'Enrolled with success.',
                data: {
                    type: "success",
                },
            });
            Inertia.get(route('challenges.show', {id: props.challenge.id}))
        }
        confirmEnroll.value = false
    })
}

const map = ref(null);

onMounted(() => {
    const _map = map.value.map;
    if (props.challenge.project) {
        const {data} = props.challenge.project;
        _map.fitBounds(data.polygon);
    }
});

</script>

